import React from 'react'
import { Box, CircularProgress } from '@mui/material'
const CircularProgressBar = ({ left = '50%', top = '50%' }) => <Box zIndex='3' position="absolute" top={top} left={left}>
    <CircularProgress />
</Box>

export default CircularProgressBar
